<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;display: flex;justify-content: space-between;align-items: center;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				我的消息
			</div>
			<span style="margin-right: 20px;font-size: 18px;cursor: pointer;color:#888">全部已读</span>
		</div>
		<div class="checkBox">
			<div @click="activeCheck = 1" :class="activeCheck == 1 ? 'checkActive':''">系统消息</div>
			<div @click="activeCheck = 2,answerMsg = [],answerCode = '',answerText = ''"
				:class="activeCheck == 2 ||activeCheck == 3 ? 'checkActive':''">站内信</div>

		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 1">
			<div v-if='false'>
				<div class="pinglun" v-for="(item,index) in message">
					<div class="tophead">
						<div>
							<div v-if="!item.read" class="read">已读</div>
							<div v-else class="read" style="color: #888;">未读</div>
							<p>{{item.title}}</p>
						</div>
						<div>
							<div v-if="item.read" @click="readed(index)" class="caozuo">标记为已读</div>
							<div class="caozuo" @click="delMsg(index)">删除</div>
						</div>
					</div>
					<div class="content">
						<div :class="'collapse'" :style="item.zhedie ?
						'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
						:''">
							{{item.content}}
						</div>
						<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
							@click='item.zhedie = !item.zhedie'>
							<div v-if="item.zhedie">展开 <i class="el-icon-caret-bottom"></i></div>
							<div v-else>收起 <i class="el-icon-caret-top"></i></div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1000">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="暂无消息"></el-empty>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 2">
			<div v-if='false'>
				<div class="SXpinglun" v-for="(item,index) in letter">
					<div class="userInfo">
						<div style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
							<img src='../../assets/images/erciyuan.png' style="width: 100%;height: 100%;" alt="">
						</div>
					</div>
					<div class="content">
						<div style="display: flex;justify-content: space-between;">
							<p style="font-size: 18px;color: black;">用户昵称123123</p>
							<div style="display: flex;">
								<div class="caozuo" @click="delLetter(index)">删除</div>
								<div class="caozuo" @click="toAnswer(item)">回复</div>
							</div>
						</div>

						<p style="font-size: 14px;margin-top: 10px;">{{item.data}}</p>
						<div :class="'collapse'" :style="item.collapse ?
						'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
						:''">
							{{item.content}}
						</div>
						<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
							@click='item.collapse = !item.collapse'>
							<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
							<div v-else>收起 <i class="el-icon-caret-top"></i></div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" :total="1000">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="暂无消息"></el-empty>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 3">
			<div class="SXpinglun" v-for="(item,index) in answerMsg">
				<div class="userInfo">
					<div style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
						<img src='../../assets/images/erciyuan.png' style="width: 100%;height: 100%;" alt="">
					</div>
				</div>
				<div class="content">
					<div style="display: flex;justify-content: space-between;">
						<p style="font-size: 18px;color: black;">用户昵称123123</p>
						<div style="display: flex;">
							<div class="caozuo" v-if="item.origin" style="color: #0052D9;" @click="delAnswer(index)">删除
							</div>
						</div>
					</div>

					<p style="font-size: 14px;margin-top: 10px;">{{item.data}}</p>
					<div :class="'collapse'" style="color: #222;">
						{{item.content}}
					</div>

				</div>
			</div>
			<div>
				<el-input type="textarea" resize='none' placeholder="请输入内容" v-model.trim="answerText">
				</el-input>
				<div style="display: flex;margin-top: 20px;align-items: center;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<input type="text" v-model.trim='answerCode'
							style="width: 133px;height: 32px;border: 1px solid #D2D2D2;">
						<div
							style="width: 77px;height: 32px;background: #D2D2D2;border: 1px solid #D2D2D2;text-align: center;line-height: 32px;">
							{{serveAnswerCode}}
						</div>
					</div>
					<div @click="answer"
						style="width: 52px;height: 24px;background: #E5EDFB;border-radius: 5px;color: #0052D9;line-height: 24px;text-align: center;cursor: pointer;">
						回复
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import timeConversion from '../../utils/timeConversion.js'
	export default {
		data() {
			return {
				activeCheck: 1,
				message: [{
						read: false,
						title: '远离侵权，拒绝盗版!',
						content: "远离侵权，拒绝盗版！远离侵权，拒绝盗版！半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、为气象研究和其他领域的发展带来了无限可能性。远离侵权，拒绝盗版！远离侵权，拒绝盗版！远离侵权，拒绝盗版！远离侵权远离侵权，拒绝盗版！，拒绝盗版！远离侵权，拒绝盗版！远离侵权，拒绝盗版！",
						zhedie: true
					},
					{
						read: true,
						title: '远离侵权，拒绝盗版!',
						content: "远离侵权，拒绝盗版！远离侵权，拒绝盗版！半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、为气象研究和其他领域的发展带来了无限可能性。远离侵权，拒绝盗版！远离侵权，拒绝盗版！远离侵权，拒绝盗版！远离侵权远离侵权，拒绝盗版！，拒绝盗版！远离侵权，拒绝盗版！远离侵权，拒绝盗版！",
						zhedie: false
					}
				],
				letter: [{
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					},
					{
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					}
				],
				answerMsg: [],
				answerText: '',
				answerCode: '',
				serveAnswerCode: 'ABCD'
			}
		},
		methods: {
			answer() {
				if (this.answerCode == '') {
					this.$message.error('请输入验证码')
					return
				}
				if (this.answerCode !== this.serveAnswerCode) {
					this.$message.error('验证码有误')
					return
				} else {
					if (this.answerText !== '') {
						let time = timeConversion(new Date())
						let ansewr = {
							origin: 1,
							data: time,
							content: this.answerText
						}
						this.answerMsg.push(ansewr)
						this.answerText = ''
						this.answerCode = ''
					}
				}
			},
			toAnswer(item) {
				console.log(item);
				this.activeCheck = 3
				this.answerMsg.push(item)
				// let time = timeConversion(new Date())
				// console.log(time);
			},
			delAnswer(index) {
				this.answerMsg.splice(index, 1)
			},
			delLetter(index) {
				this.letter.splice(index, 1)
			},
			delMsg(index) {
				this.message.splice(index, 1)
			},
			readed(index) {
				this.message[index].read = false
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.el-textarea__inner {
		color: #222;
		font-size: 16px;
		height: 184px;
		border: 1px solid #E5E5E5;
		font-family: none;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #0052D9;
	}

	.SXpinglun {
		.caozuo {
			background-color: #EEEEEE;
			color: #888;
			padding: 0 15px;
			margin-left: 15px;
			cursor: pointer;
		}

		.collapse {
			margin-top: 5px;
		}

		color: #909090;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;

		.content {
			margin-left: 28px;
			flex: 1;


			&>p {}
		}

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: center;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.pinglun {
		.tophead {
			display: flex;
			justify-content: space-between;

			&>div {
				display: flex;

				.read {
					width: 49px;
					height: 24px;
					background-color: #E5EDFB;
					color: #0052D9;
					text-align: center;
					line-height: 24px;
					font-size: 18px;
				}

				.caozuo {
					background-color: #EEEEEE;
					color: #888;
					padding: 0 15px;
					margin-left: 15px;
					cursor: pointer;
				}

				&>p {
					margin-left: 15px;
					font-size: 18px;
					font-weight: bold;
				}
			}

		}

		.collapse {
			margin-top: 15px;
		}

		.content {
			color: #909090;
		}

		box-sizing: border-box;
		border-bottom: 1px dashed #eee;
		padding-bottom: 40px;
		margin-bottom: 30px;

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: flex-start;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.checkBox {
		padding: 0 20px;
		font-size: 18px;
		display: flex;
		height: 80px;
		line-height: 80px;
		cursor: pointer;
		border-bottom: 1px solid #ECECEC;

		div {
			margin-right: 60px;
		}

		.checkActive {
			font-weight: bold;
			color: #0052D9;
			border-bottom: 5px solid #0052D9;
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 860px;
		box-sizing: border-box;
		background: #fff;
	}
</style>